/*
	Copyright (c) 2022 PierceGearhart
    StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (StellaNode).
*/

const Card: React.FC = ({ children }) => {
    return (
        <div className="bg-primary-light shadow-xl py-5 px-6 rounded-md">
            {children}
        </div>
    )
}

export default Card